export function BetaTag({}) {
    return <sup style={{fontSize: '0.6rem'}}>BETA</sup>
}
